
  window.bssB2BHooks = window.bssB2BHooks || { actions: {}, filters: {} };

  window.bssB2BHooks.filters['custom:comparePrice/td'] = function(comparePrice, args) {
    var variant = args && args.variant;
    if (variant && variant.compare_at_price && Number(variant.compare_at_price) > Number(variant.price)) {
      return Number(variant.compare_at_price);
    }
    return comparePrice;
  };

  function renderCustomB2BPrice(container, data) {
    if (!container) return;

    var priceNoVat = data.priceNoVat || '';
    var priceHasVat = data.priceHasVat || '';
    var comparePriceNoVat = data.comparePriceNoVat || '';
    var comparePriceHasVat = data.comparePriceHasVat || '';
    var variant = data.variant;

    var currentPriceHtml = priceNoVat + priceHasVat;
    var comparePriceHtml = comparePriceNoVat + comparePriceHasVat;

    var discountPercent = 0;
    if (variant && variant.compare_at_price && Number(variant.compare_at_price) > Number(variant.price)) {
      var cPrice = Number(variant.compare_at_price);
      var pPrice = Number(variant.price);
      discountPercent = Math.round(((cPrice - pPrice) / cPrice) * 100);
    } else if (data.priceAfterTd && data.priceAfterTd.comparePriceNoVat && data.priceAfterTd.priceNoVat) {
      var cPrice = data.priceAfterTd.comparePriceNoVat;
      var pPrice = data.priceAfterTd.priceNoVat;
      if (cPrice > pPrice) {
        discountPercent = Math.round(((cPrice - pPrice) / cPrice) * 100);
      }
    }

    var html = '<div class="price flex flex-row gap-1 md:gap-x-2 h3 gap-y-0.5 items-center flex-wrap price-wrapper heading-medium" style="display:flex; flex-direction:row; align-items:center; flex-wrap:wrap; gap:6px 8px;">';
    
    var currentPriceColor = comparePriceHtml ? '#a92222' : '#000000';
    if (currentPriceHtml) {
      currentPriceHtml = currentPriceHtml.replace(/color:\s*[^;"]+/gi, 'color: ' + currentPriceColor);
    }

    html += '<span class="price" style="color: ' + currentPriceColor + ';">' + currentPriceHtml + '</span>';

    if (comparePriceHtml) {
      html += '<span class="compare-at-price line-through" style="text-decoration: line-through;">' + comparePriceHtml + '</span>';
    }

    if (discountPercent > 0) {
      html += '<div class="price-label__wrapper flex items-center" style="display:inline-flex; align-items:center;">';
      html += '  <div class="price-label h-fit inline-block relative h7 pt-1 pb-1 pl-2 pr-2 rounded" style="background-color: rgba(169, 34, 34, 0.1); color: var(--color-sale-price, #a92222); padding: 2px 8px; border-radius: 4px; font-size: 0.75rem; font-weight: 600; line-height: 1.2;">';
      html += '    -' + discountPercent + '%';
      html += '  </div>';
      html += '</div>';
    }

    html += '</div>';

    container.innerHTML = html;
  }

  window.bssB2BHooks.actions['custom:TdProduct/showPriceBase'] = function(data) {
    renderCustomB2BPrice(data.priceElement, data);
  };

  window.bssB2BHooks.actions['custom:TdProductList/showPrice'] = function(data) {
    var element = data.element;
    var comparePriceNoVat = data.comparePriceNoVat || '';
    var comparePriceHasVat = data.comparePriceHasVat || '';
    var priceNoVat = data.priceNoVat || '';
    var priceHasVat = data.priceHasVat || '';
    if (element && (comparePriceNoVat || comparePriceHasVat)) {
      element.innerHTML = comparePriceNoVat + comparePriceHasVat + priceNoVat + priceHasVat;
    }
  };

